//snippet rxconst
export const DOCTOR_CATEGORY_FETCH_INIT = "DOCTOR_CATEGORY_FETCH_INIT";
export const DOCTOR_CATEGORY_FETCH_SUCCESS = "DOCTOR_CATEGORY_FETCH_SUCCESS";
export const DOCTOR_CATEGORY_FETCH_FAIL = "DOCTOR_CATEGORY_FETCH_FAIL";
//plopImport
